import { Box, useTheme } from '@mui/material';

const ResourceBar = ({ value, max, color }) => {
  const percent = (value / max) * 100;
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box>
      <Box
        sx={{
          height: 20,
          borderRadius: '10px',
          backgroundColor: isDarkMode ? '#333' : '#ccc',
          overflow: 'hidden',
          boxShadow: isDarkMode ? 'inset 0 0 4px #000' : 'inset 0 0 4px #aaa',
        }}
      >
        <Box
          sx={{
            height: '100%',
            width: `${percent}%`,
            backgroundColor: color,
            transition: 'width 0.3s ease',
          }}
        />
      </Box>
    </Box>
  );
};

export default ResourceBar;
